import isEqual from 'lodash/isEqual'
import React, { FC } from 'react'

import { ControlButtonFilter } from './ControlButtonFilter'
import * as S from './ControlButtonsFilter.styles'
import { FilterButtonsGroupProps } from './ControlButtonsFilter.types'

export const ControlButtonsFilter: FC<FilterButtonsGroupProps> = ({
  allowNoSelectedValue = true,
  className,
  options,
  groupLabel,
  currentValue,
  multipleSelect,
  onClick,
}) => {
  const handleClick = (value: any) => () => {
    if (multipleSelect) {
      if (!allowNoSelectedValue && currentValue?.includes(value) && currentValue.length === 1) {
        return
      }

      if (Array.isArray(currentValue)) {
        onClick(
          currentValue.includes(value)
            ? currentValue.filter(v => v !== value)
            : [...currentValue, value],
        )
      } else {
        onClick(currentValue && currentValue !== value ? [currentValue, value] : [value])
      }
    } else {
      if (!allowNoSelectedValue && value === currentValue) {
        return
      }

      onClick(value === currentValue ? undefined : value)
    }
  }

  const isValueChecked = (optionValue: any) => {
    const isCurrentValueArray = Array.isArray(currentValue)
    if (multipleSelect && isCurrentValueArray) {
      return currentValue.includes(optionValue.value)
    }

    if (isCurrentValueArray) {
      return isEqual(currentValue, optionValue)
    }

    return optionValue === currentValue
  }

  return (
    <S.ButtonsGroup className={className}>
      {options.map(option => {
        const checked = isValueChecked(option.value)

        return (
          <ControlButtonFilter
            key={option.id}
            id={option.id}
            value={option.value}
            title={option.title}
            count={option.count}
            disabled={option.disabled}
            label={groupLabel}
            defaultChecked={option.defaultChecked}
            checked={checked}
            className={option.className}
            multipleSelect={multipleSelect}
            onClick={handleClick(option.value)}
          >
            {option.children}
          </ControlButtonFilter>
        )
      })}
    </S.ButtonsGroup>
  )
}
